import api from './api';
import {
    SCORM_UPLOAD,
    SCORM_LIST,
    SCORM_LIST_FILES,
    SCORM_START_CONTENT_EXTRACTION,
    CONTENT_EXTRACTIONS,
    DELETE_EXTRACTION_ROUTE,
    SCORM_FILE_DETAILS,
    SCROM_FILE_CONTENT_PREVIEW,
    SCORM_LIST_SORT_BY_TEAMS_APPS,
} from '../configs/routes';

export const uploadScormFile = (file, onUploadProgress, force = true) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('force', force);
    return new Promise((resolve, reject) => {
        api.post(SCORM_UPLOAD, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress,
        })
            .then((data) => resolve(data.data))
            .catch((err) => {
                // Preserve the error structure with code and message

                reject(err);
            });
    });
};

export const deleteScormFileApi = (id) =>
    new Promise((resolve, reject) => {
        api.delete(SCORM_FILE_DETAILS(id))
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data?.message || err.message || 'Failed to delete scorm file'));
    });

export const fetchScormFiles = (page = 1, limit = 5, search, timeFilter, sortOptions, isExtractionCompleted) => {
    const url = `${SCORM_LIST}?${new URLSearchParams({
        page: String(page),
        page_size: String(limit),
        ...(isExtractionCompleted && { last_extraction_status: 'completed' }),
        ...(search && { search }),
        ...(timeFilter && timeFilter !== 'all' && { date_filter: timeFilter }),
        ...(sortOptions && { sort_field: sortOptions.field, sort_order: sortOptions.sort }),
    }).toString()}`;

    return api.get(url);
};

export const fetchScormFilesWithTeamsApp = (page = 1, limit = 5, search) => {
    const url = `${SCORM_LIST_SORT_BY_TEAMS_APPS}?${new URLSearchParams({
        page: String(page),
        page_size: String(limit),
        ...(search && { search }),
    }).toString()}`;

    return api.get(url);
};

export const fetchFileApi = (fileId) => {
    return api.get(SCROM_FILE_CONTENT_PREVIEW(fileId));
};

export const fetchScormFileList = (id) => {
    return api.get(SCORM_LIST_FILES(id));
};

export const startContentExtraction = (file_id) => {
    return api.post(SCORM_START_CONTENT_EXTRACTION, { file_id });
};

export const fetchContentExtractions = (page = 1) => {
    return api.get(CONTENT_EXTRACTIONS(page));
};

export const fetchScormFileDetails = (id) => {
    return api.get(`/scorm-files/${id}/`);
};

export async function deleteContentExtraction(processId) {
    return new Promise((resolve, reject) => {
        api.delete(DELETE_EXTRACTION_ROUTE(processId))
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data?.message || err.message || 'Failed to delete extraction'));
    });
}
